<section class="rounded-lg border border-greyscale-200 bg-primary-50">
  <div class="p-2 md:p-6">
    <div
      class="mb-6 flex flex-col-reverse items-center justify-between gap-6 md:flex-row"
    >
      <div class="flex flex-col gap-4 md:flex-row md:items-center">
        <h2 class="text-2xl font-bold text-[#293834]">
          {{ "impact.overview.title" | transloco }}
        </h2>
        <!-- SelectButton pour mode Groupe/Individuel -->
        <div class="flex items-center gap-2">
          <p-selectButton
            [options]="viewModeOptions"
            [(ngModel)]="impactService.viewMode"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false"
            styleClass="p-selectbutton-sm"
            size="small"
          ></p-selectButton>
          <app-tooltip-icon
            position="right"
            message="{{ 'impact.viewMode.tooltip' | transloco }}"
          />
        </div>
      </div>
      <div class="flex items-center gap-4">
        <button
          class="rounded border border-[#527A6D] px-4 py-2 text-sm font-medium text-[#527A6D] hover:bg-white/50"
          (click)="onEditTrip()"
        >
          {{ "impact.overview.editTrip" | transloco }}
        </button>
      </div>
    </div>

    <div>
      <!-- Layout 2 colonnes -->
      <div class="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <!-- Graphique donut Chart.js -->
        <div class="h-fit rounded-lg bg-white p-4">
          <!-- Contrôles en haut -->
          <app-impact-chart-controls
            [groupTransports]="groupTransports"
            [excludeMainTransport]="excludeMainTransport"
            [logoSources]="getLogoSources()"
            [logoPosition]="logoPosition"
            [logoSourceId]="getSelectedLogoSourceId()"
            (groupTransportsChange)="onGroupTransportsChange($event)"
            (excludeMainTransportChange)="onExcludeMainTransportChange($event)"
            (logoPositionChange)="onLogoPositionChange($event)"
            (logoSourceIdChange)="onLogoSourceChange($event)"
          ></app-impact-chart-controls>

          <!-- Graphique centré -->
          <div
            class="relative flex flex-col items-center overflow-hidden p-4 md:p-8"
          >
            <!-- isolate: keeps the z-index below local, so the "side" logo still paints above the chart -->
            <div class="relative isolate">
              <!-- Above the logo: tooltips are painted into the canvas, so a DOM
                   overlay would hide them. The doughnut hole is transparent. -->
              <app-chart-doughnut
                class="relative z-10"
                [data]="getChartData()"
                [size]="chartSize.getSize('impactOverview')"
                [centerValue]="isLogoCentered() ? undefined : getCenterValue()"
                [centerLabel]="isLogoCentered() ? undefined : getCenterLabel()"
                [thickness]="chartSize.getThickness('impactOverview')"
                [showLabelInTooltip]="true"
              >
              </app-chart-doughnut>
              <!-- Logo au centre du donut -->
              @if (isLogoCentered()) {
                <img
                  [src]="getSelectedLogoUrl()"
                  alt=""
                  class="pointer-events-none absolute inset-0 m-auto rounded-full bg-white object-contain"
                  [style.width.px]="getLogoDiameter()"
                  [style.height.px]="getLogoDiameter()"
                  (error)="onLogoError()"
                />
              }
            </div>
            <!-- Logo en bas à droite de la zone du graphique -->
            @if (logoPosition === "side" && getSelectedLogoUrl()) {
              <img
                [src]="getSelectedLogoUrl()"
                alt=""
                class="absolute bottom-2 right-2 h-16 w-16 rounded-full object-contain md:h-24 md:w-24"
                (error)="onLogoError()"
              />
            }
            <!-- Total déplacé sous le graphique quand le logo occupe le centre -->
            @if (isLogoCentered()) {
              <div
                class="mt-8 flex w-full items-baseline justify-between border-t border-greyscale-200 pt-4"
              >
                <span class="text-sm font-medium text-greyscale-600">
                  {{ "impact.overview.totalEmissions" | transloco }}
                </span>
                <span class="flex items-baseline gap-2">
                  <span class="text-3xl font-bold tabular-nums text-greyscale-900 md:text-4xl">
                    {{ getCenterValue() }}
                  </span>
                  <span class="text-sm font-medium text-greyscale-600">
                    {{ getCenterLabel() }}
                  </span>
                </span>
              </div>
            }
          </div>
        </div>

        <!-- Détails et légende enrichie -->
        <div class="rounded-lg bg-white p-6">
          <!-- Légende détaillée par catégorie -->
          <div class="space-y-8">
            <!-- En-tête de la légende -->
            <div
              class="flex items-center justify-between border-b border-greyscale-200 pb-2"
            >
              <span class="text-sm font-medium text-greyscale-600">
                {{ "impact.overview.detailedLegend" | transloco }}
              </span>
              <button
                class="rounded-lg p-1 text-sm text-greyscale-500 transition-colors hover:bg-greyscale-50 hover:text-greyscale-700"
                (click)="toggleAllSections()"
                [pTooltip]="'impactReport.page.expandCollapse' | transloco"
                tooltipPosition="top"
              >
                <lucide-angular
                  [img]="allSectionsOpen ? chevronsUpIcon : chevronsDownIcon"
                  class="h-4 w-4"
                >
                </lucide-angular>
              </button>
            </div>

            <!-- Pour chaque catégorie -->
            @for (
              category of getLegendData();
              track category.translationKey;
              let categoryIndex = $index
            ) {
              <app-impact-legend-category
                [category]="category"
                [categoryIndex]="categoryIndex"
                [perPerson]="impactService.perPerson()"
                (categoryToggle)="toggleCategory(category)"
                (categoryHeaderHover)="
                  onCategoryHeaderHover(category, categoryIndex)
                "
                (categoryHeaderLeave)="onLegendItemLeave()"
                (itemHover)="
                  onLegendItemHover(
                    category.items[$event],
                    $event,
                    categoryIndex
                  )
                "
                (itemLeave)="onLegendItemLeave()"
              ></app-impact-legend-category>
            } @empty {
              <div class="py-8 text-center text-greyscale-500">
                <span class="text-sm italic">{{
                  "impact.overview.noData" | transloco
                }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
